import { findInArray } from 'owa-calendar-data-utils/lib/findInArray';
import { SurfaceItem } from 'owa-calendar-surface-dategrid';

/**
 * Find the row index for a given all day item
 * @param model The model for the item we are searching for
 * @param allDayRows The all day items rows
 * @returns The row index for the item, or -1 if not found
 */
export default function findAllDayItemRow(model: any, allDayRows: SurfaceItem[][]): number {
    for (let i = 0, length = allDayRows.length; i < length; i++) {
        let result = findInArray(allDayRows[i], item => item.model == model);
        if (result && result.index > -1) {
            return i;
        }
    }

    // Not found
    return -1;
}
